import './TableCardStyle.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { Button, Spacer, Title, Visible } from 'src/core/components';

import messages from './messages';

const TableCardComponent = ({
  title,
  subtitle,
  children,
  onViewAll,
  expanded,
}) => (
  <div className="c-card table-card">
    <Title size="2" message={title} />
    <Spacer bottom={4} />
    <Title size="3" font="thin" message={subtitle} />
    <Spacer bottom={24} />

    <div className="table-card__content">{children}</div>

    <Visible when={!expanded}>
      <Spacer bottom={24} />
      <Button
        data-testid="view-all-button"
        type="tertiary"
        label={messages.viewAll}
        onClick={onViewAll}
      />
    </Visible>
  </div>
);

TableCardComponent.propTypes = {
  title: PropTypes.object,
  subtitle: PropTypes.object,
  children: PropTypes.node,
  expanded: PropTypes.bool,
  onViewAll: PropTypes.func,
};

export default TableCardComponent;
